package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AvailabilityRepository

class GetAvailableTimeSlotsUseCase(
    private val repository: AvailabilityRepository
) {
    suspend operator fun invoke(dateIso: String, serviceDurationMinutes: Int = 30): List<String> {
        return repository.getAvailableTimeSlots(dateIso, serviceDurationMinutes)
    }
}
